module.exports = __webpack_public_path__ + "src/assets/textures/env/barn/windows_1K_bake.png";